/**
 * Font families available in the Landing Page Builder
 * These fonts are loaded from Google Fonts
 */
export interface BuilderFont {
  name: string;
  value: string;
  category: 'serif' | 'sans-serif' | 'display' | 'handwriting' | 'monospace';
}

export const BUILDER_FONTS: BuilderFont[] = [
  // Sans-serif fonts
  { name: 'Inter', value: 'Inter', category: 'sans-serif' },
  { name: 'Roboto', value: 'Roboto', category: 'sans-serif' },
  { name: 'Open Sans', value: 'Open Sans', category: 'sans-serif' },
  { name: 'Lato', value: 'Lato', category: 'sans-serif' },
  { name: 'Montserrat', value: 'Montserrat', category: 'sans-serif' },
  { name: 'Poppins', value: 'Poppins', category: 'sans-serif' },
  { name: 'Raleway', value: 'Raleway', category: 'sans-serif' },
  { name: 'Ubuntu', value: 'Ubuntu', category: 'sans-serif' },

  // Serif fonts
  { name: 'Playfair Display', value: 'Playfair Display', category: 'serif' },
  { name: 'Merriweather', value: 'Merriweather', category: 'serif' },
  { name: 'Lora', value: 'Lora', category: 'serif' },
  { name: 'PT Serif', value: 'PT Serif', category: 'serif' },
  { name: 'Crimson Text', value: 'Crimson Text', category: 'serif' },

  // Display fonts
  { name: 'Oswald', value: 'Oswald', category: 'display' },
  { name: 'Bebas Neue', value: 'Bebas Neue', category: 'display' },
  { name: 'Anton', value: 'Anton', category: 'display' },
  { name: 'Righteous', value: 'Righteous', category: 'display' },

  // Handwriting fonts
  { name: 'Dancing Script', value: 'Dancing Script', category: 'handwriting' },
  { name: 'Pacifico', value: 'Pacifico', category: 'handwriting' },
  { name: 'Satisfy', value: 'Satisfy', category: 'handwriting' },

  // Monospace fonts
  { name: 'Roboto Mono', value: 'Roboto Mono', category: 'monospace' },
  { name: 'Source Code Pro', value: 'Source Code Pro', category: 'monospace' },
];

const BUILDER_FONT_QUERIES: Readonly<Record<string, string>> = {
  Inter: 'Inter:wght@400;500;600;700',
  Roboto: 'Roboto:wght@400;500;700',
  'Open Sans': 'Open+Sans:wght@400;600;700',
  Lato: 'Lato:wght@400;700',
  Montserrat: 'Montserrat:wght@400;500;600;700',
  Poppins: 'Poppins:wght@400;500;600;700',
  Raleway: 'Raleway:wght@400;500;600;700',
  Ubuntu: 'Ubuntu:wght@400;500;700',
  'Playfair Display': 'Playfair+Display:wght@400;500;600;700',
  Merriweather: 'Merriweather:wght@400;700',
  Lora: 'Lora:wght@400;500;600;700',
  'PT Serif': 'PT+Serif:wght@400;700',
  'Crimson Text': 'Crimson+Text:wght@400;600;700',
  Oswald: 'Oswald:wght@400;500;600;700',
  'Bebas Neue': 'Bebas+Neue',
  Anton: 'Anton',
  Righteous: 'Righteous',
  'Dancing Script': 'Dancing+Script:wght@400;500;600;700',
  Pacifico: 'Pacifico',
  Satisfy: 'Satisfy',
  'Roboto Mono': 'Roboto+Mono:wght@400;500;600;700',
  'Source Code Pro': 'Source+Code+Pro:wght@400;500;600;700',
};

/**
 * Generates Google Fonts URL for all builder fonts
 */
export function getGoogleFontsUrl(): string {
  const families = BUILDER_FONTS.map(font =>
    BUILDER_FONT_QUERIES[font.value]
  ).join('&family=');

  return `https://fonts.googleapis.com/css2?family=${families}&display=swap`;
}

/**
 * Default font family for text nodes
 */
export const DEFAULT_FONT_FAMILY = 'Inter';
